import { create } from "zustand";

interface cacheState {
    useDrawer: boolean;
    drawerContent: string | JSX.Element;
    unsetDrawer?: boolean;
}

const UIStore = create<cacheState>()((set) => ({
    useDrawer: false,
    drawerContent: "",
    unsetDrawer: false,
}));

export default UIStore;
